import _ from "lodash";
import {
  getDefaultOrderSettings,
  getProcessingFeeCapOffValue,
  getOfficialBundleMappingRedis,
}
  from "@/api/va-order-page/orderTest.js";
import { getCountryList } from "@/api/va-order-page/pricing/shipping.js";
import { addSelectedTest, removeSelectedTest } from "@/utils/va-order-test/testAndPanelSelection/testSelection.js";
import { addSelectedDiscountPanel, removeSelectedDiscountPanel } from '@/utils/va-order-test/testAndPanelSelection/discountPanelSelection';
import { addSelectedXChooseYPanel, removeSelectedXChooseYPanel } from '@/utils/va-order-test/testAndPanelSelection/xChooseYPanelSelection.js';
import { addSelectedCustomPanel, removeSelectedCustomPanel } from '@/utils/va-order-test/testAndPanelSelection/customPanelSelection.js';
import { addSelectedSeasonalPromo, removeSelectedSeasonalPromo } from '@/utils/va-order-test/testAndPanelSelection/seasonalPromoSelection.js';
import { addSelectedShortcut, removeSelectedShortcut } from '@/utils/va-order-test/testAndPanelSelection/shortcutSelection.js';
import { clearAllSelectedItems } from '@/utils/va-order-test/testAndPanelSelection/index.js';
import { getItemsPrice, getVwTestsPrice } from "@/utils/va-order-test/index.js";
import { getOrderItemList } from "@/views/va-orderTest/order-page/order-summary/SummaryAccessories/getOrderItemListFunc.js";
import { formatDataForFrontendTable } from "@/views/va-orderTest/merch/helpers/dataFomatter.js"
import user from "./user.js";
import tests from "./tests.js";
import panels from './panels.js';
import order from "./order.js";
import favorites from './favorites.js';
import program from './program.js';
import promotions from "./promotions.js";
import orderDraft from "./orderDraft.js";
import noteTemplate from './noteTemplate.js';
import exceptions from "./exceptions.js";
import redirect from "./redirect.js";
import merchandise from "./merchandise.js"
import familyDiscount from "./familyDiscount.js"
// import merchPromotion from './merchPromotion.js'
import { getModifiedDiscountMap, setItemMarkupPriceAndVersion } from "./helpers/index.js";
import { getAllDescendants } from "@/utils/va-order-test/testAndPanelSelection/testSelection.js";
import { getParamsFromURL } from "@/utils/va-order-test/url.js";
import { getOrderMarkupSchemesApi, getAllMerchandisesForOrder } from "@/api/markup";
import { getOfficialBundleMappingApi, getBestDealMapping } from "@/api/va-order-page/pricing/item/price.js";
import { parseJson } from "@/utils";

const orderTest = {
  namespaced: true,
  state: {
    countryOptions: [],
    isClickCheckout: false,
    duplicatedTests: [], // array of object. {testName: "Wheat Zoomer", testId: test_1, duplicatedTestsFrom: ['Anti-aging','Imflamation Advanced']}
    testSuggestions: [],
    defaultSettings: {},
    discountMap: {},
    bundleReplaceTriggered: 0,
    isDbsVersion: false,
    dbsMap: [],
    switchToDbs: 0,
    switchToSerum: 0,
    searchTestOptions: [],
    isBackFromCheckoutPage: false,
    processingAndCapOffValue: {},
    isPatientInfoInSessionStorage: 0, // change from boolean check to number increment check, in order to handle "choose promo first, add patient later " feature 
    patientAreaCodeChangeCount: 0,
    isAddOnOrder: '',
    addOnFixedVaVwTestWithParents: new Map(),
    addOnFixedVaVwTest: new Map(),
    addOnFixedDiscountPanel: new Map(),
    addOnFixedCustomPanel: [],
    addOnFixedFavPanel: [],
    addOnFixedVaVwTestTubeInfo: new Map(),
    addOnRequiredMoreNoOfTubesTests: [],
    addOnAccessionId: '',
    addOnExpiredTestList: [],
    addOnExpiredSoonAddonTests: new Map(),
    addOnPrice: 0,
    addOnFixedPromo: [],
    addOnSelectedItemList: {},
    addOnPrevTubeInfoApiCount: 0,
    addOnPrevTubeInfo: new Map(),
    addOnShortcutRequiredMoreNoOfTubesTests: [],
    addOnCustomRequiredMoreNoOfTubesTests: [],
    bestDealSupportMapping: {},
    isRestoringItems: false
  },
  getters: {
    addOnselectedItemList(state, getters, dispatch) {
      // prevent calling from other places but not add on order
      if (!state.isAddOnOrder) {
        return { addOnSelectedItemList: [], selectedItemOrderList: [] }
      }
      let addOnSelectedItemList = []
      let selectedItemOrderList = []
      let addOnPrice = 0

      for (let i = 0; i < state.promotions.selectedSeasonalPromoList.length; i++) {
        let item = state.promotions.selectedSeasonalPromoList[i]

        if (state.addOnFixedPromo.includes(item.id)) {
          addOnSelectedItemList.push(item)

        } else {
          // only display promotion if previous add on order has already ordered that promotion
          // otherwise,
          // remove selected promo and add as a va vw test
          removeSelectedSeasonalPromo(item, "isSelect", getters.orderTestSupportObj);
          let index = state.promotions.seasonalPromotionList.findIndex(x => x.id === item.id);
          state.promotions.seasonalPromotionList.splice(index)

          item.appliedTests.forEach(i => {
            addSelectedTest(i, "isSelect", getters.orderTestSupportObj);
          })

        }
      }

      for (let i = 0; i < getters["tests/selectedTestList"].length; i++) {
        let item = getters["tests/selectedTestList"][i]

        // exception list frontend creates a fake root with negative id number
        if (item.id < 0) {
          let packageTests = item.packageTests.map(i => i.id)
          let addOnFixedVaVwTestArr = Array.from(state.addOnFixedVaVwTest.keys())
          const result = packageTests.every(val => addOnFixedVaVwTestArr.includes(val));
          // if descendants all includes in addOnSelectedItemList, it is a fake root
          if (result) {
            addOnSelectedItemList.push(item)
            continue
          }
        }

        if (state.addOnFixedVaVwTest.has(item.id)) {
          addOnSelectedItemList.push(item)
        } else {
          selectedItemOrderList.push(item)
          addOnPrice += item.price
        }
      }

      for (let i = 0; i < getters["panels/selectedDiscountPanelList"].length; i++) {
        let item = getters["panels/selectedDiscountPanelList"][i]
        if (state.addOnFixedDiscountPanel.has(item.bundleId)) {
          addOnSelectedItemList.push(item)
        } else {
          selectedItemOrderList.push(item)
          addOnPrice += item.price
        }
      }

      for (let i = 0; i < getters["panels/selectedXChooseYPanelList"].length; i++) {
        let item = getters["panels/selectedXChooseYPanelList"][i]
        if (state.addOnFixedDiscountPanel.has(item.bundleId)) {
          addOnSelectedItemList.push(item)
        } else {
          selectedItemOrderList.push(item)
          addOnPrice += item.price
        }
      }



      for (let i = 0; i < getters["favorites/selectedShortcutList"].length; i++) {
        let item = getters["favorites/selectedShortcutList"][i]
        if (state.addOnFixedFavPanel.includes(item.bundleId)) {
          addOnSelectedItemList.push(item)
        } else {
          selectedItemOrderList.push(item)
          addOnPrice += item.price
        }
      }

      for (let i = 0; i < getters["panels/selectedCustomPanelList"].length; i++) {
        let item = getters["panels/selectedCustomPanelList"][i]
        if (state.addOnFixedCustomPanel.includes(item.bundleId)) {
          addOnSelectedItemList.push(item)
        } else {
          selectedItemOrderList.push(item)
          addOnPrice += item.price
        }
      }

      state.addOnPrice = addOnPrice

      state.addOnSelectedItemList = { ...addOnSelectedItemList }

      // will display two sections when add on order; the first section has tests from 
      // add on order, the second secion has newly added tests. 
      // else only display the second section if the order is not add on order.
      return { addOnSelectedItemList, selectedItemOrderList }
    },

    selectedItemList(state, getters) {
      return getters["panels/selectedCustomPanelList"]
        .concat(getters["favorites/selectedShortcutList"])
        .concat(state.promotions.selectedSeasonalPromoList)
        .concat(getters["panels/selectedDiscountPanelList"])
        .concat(getters["panels/selectedXChooseYPanelList"])
        .concat(getters["tests/selectedTestList"])
        .concat(getters["program/selectedProgramList"]);
    },

    // price for ordered vw tests (exclude heavy metal) - inlclude bundle & shortcut contaning vw tests
    selectedVwTestPrice: (state, getters) => {
      let itemList = getters.selectedItemList.filter(item => item.category !== "shortcut")
        .concat(getters["favorites/itemsInSelectedShortcuts"]);
      let vwPrice = getVwTestsPrice(itemList, getters["tests/vwTestList"]);
      return vwPrice;
    },
    // total price for selectedItemList
    selectedItemsPrice(state, getters) {
      let itemList = getters.selectedItemList.filter(item => item.category !== "shortcut")
        .concat(getters["favorites/itemsInSelectedShortcuts"]);
      return getItemsPrice(itemList);
    },

    containVwTestInSelectedShortcut(state, getters) {
      if (getters["favorites/selectedShortcutList"].length === 0) {
        return false;
      }

      return getters["favorites/selectedShortcutList"].some(i => {
        let { testIdList, discountPanelIdList, customPanelIdList, xChooseYIdList } = i;
        // selected shortcut has discount panel containing vw tests
        let selectShortcuthasBundleContainVW = state.panels.discountPanelList
          .filter(panel => discountPanelIdList.includes(panel.bundleId))
          .some(panel => {
            let idList = panel.bundleContent.packageList.map(p => p.packageId)
              .concat(panel.bundleContent.testList.map(t => t.testId));
            if (idList.some(id => getters["tests/vwTestList"].map(t => t.id).includes(id))) {
              return true;
            }
          });
        // selected shortcut has custom panel containing vw tests
        let selectShortcuthasCustomPanelContainVW = state.panels.customPanelList
          .filter(panel => customPanelIdList.includes(panel.bundleId))
          .some(panel => {
            if (panel.selectedXChooseYPanelList.length > 0)
              return true;
            else {
              let idList = panel.bundleItemList
                .filter(content => content.itemType !== "official bundle")
                .map(content => content.itemId);
              if (idList.some(id => getters["tests/vwTestList"].map(t => t.id).includes(id)))
                return true;
            }
          });
        // check if there exists any panel in selected shortcut contain vw tests
        return getters["tests/vwTestList"].map(i => i.id).filter(x => testIdList.includes(x)).length > 0 ||
          selectShortcuthasBundleContainVW ||
          selectShortcuthasCustomPanelContainVW ||
          xChooseYIdList.length > 0
      })
    },

    orderTestSupportObj: (state, getters) => {
      return {
        testNodeList: getters["tests/bfsTestList"],
        vaRootNodeList: state.tests.vaRootNodeList,
        vwRootNodeList: state.tests.vwRootNodeList,
        regenereNodeList: getters["tests/regenereNodeList"],
        nutriprozNodeList: getters["tests/nutriprozNodeList"],
        bundleList: getters["panels/bundleList"],
        seasonalPromotionList: state.promotions.seasonalPromotionList,
        shortcutList: state.favorites.shortcutList,
        exceptionMap: state.exceptions.exceptionMap,
        dbsMap: state.dbsMap,
        selectedTestIdList: state.tests.selectedTestIdList,
        selectedDiscountPanelIdList: state.panels.selectedDiscountPanelIdList,
        selectedXChooseYPanelIdList: state.panels.selectedXChooseYPanelIdList,
        selectedCustomPanelIdList: state.panels.selectedCustomPanelIdList,
        selectedSeasonalPromoList: state.promotions.selectedSeasonalPromoList,
        selectedShortcutIdList: state.favorites.selectedShortcutIdList,
        selectedItemList: getters.selectedItemList,
        editOrderItemList: state.orderDraft.editOrderItemList,
        bestDealSupportMapping: state.bestDealSupportMapping,
      }
    },

    orderItemListForApi(state, getters) {
      let data = {
        selectedItemList: getters.selectedItemList,
        testNodeList: getters["tests/bfsTestList"],
        selectedVwTestPrice: getters.selectedVwTestPrice,
        selectedDiscountPanelList: getters["panels/selectedDiscountPanelList"],
        selectedCustomPanelList: getters["panels/selectedCustomPanelList"],
        selectedXChooseYPanelList: getters["panels/selectedXChooseYPanelList"],
        selectedSeasonalPromoList: state.promotions.selectedSeasonalPromoList,
        testList: getters["tests/testList"],
        bundleList: getters["panels/bundleList"],
        editOrderItemList: state.orderDraft.editOrderItemList,
        paymentMethod: state.order.paymentMethod,
        isMarkupEligible: getters["order/isMarkupEligible"],
        selectedMerchList: getters["merchandise/selectedMerchList"],
        selectedProgramList: getters["program/selectedProgramList"],
      };

      return getOrderItemList(data);
    },

  },
  mutations: {
    SET_COUNTRY_OPTIONS(state, countryList) {
      state.countryOptions = countryList;
    },
    SET_DUPLICATE_TEST(state, payload) {
      state.duplicatedTests = payload
    },

    SET_IS_CLICK_CHECKOUT(state, isClicked) {
      state.isClickCheckout = isClicked;
    },

    SET_TEST_SUGGESTIONS(state, testSuggestions) {
      state.testSuggestions = testSuggestions;
    },

    SET_DEFAULT_SETTINGS(state, defaultSettings) {
      state.defaultSettings = defaultSettings;
    },

    SET_PROCESSING_CAP_OFF_VALUE(state, processingAndCapOffValue) {
      state.processingAndCapOffValue = processingAndCapOffValue;
    },

    SET_DISCOUNT_MAP(state, discountMap) {
      state.discountMap = discountMap;
    },

    SET_BUNDLE_REPLACE_TRIGGERED(state) {
      state.bundleReplaceTriggered += 1;
    },

    SET_IS_DBS_VERSION(state, isDbsVersion) {
      state.isDbsVersion = isDbsVersion;
    },

    SET_DBS_MAP(state, dbsMap) {
      state.dbsMap = dbsMap;
    },

    SET_BEST_DEAL_MAPPING(state, bestDealSupportMapping) {
      state.bestDealSupportMapping = bestDealSupportMapping
    },

    SWITCH_TO_DBS(state) {
      state.switchToDbs += 1;
    },

    SWITCH_TO_SERUM(state) {
      state.switchToSerum += 1;
    },

    SET_SEARCH_TEST_OPTIONS(state, searchTestOptions) {
      state.searchTestOptions = searchTestOptions;
    },
    SET_IS_BACK_FROM_CHECKOUT_PAGE(state, isBackFromCheckoutPage) {
      state.isBackFromCheckoutPage = isBackFromCheckoutPage;
    },
    SET_IS_RESTORING_ITEMS(state, val) {
      state.isRestoringItems = val;
    },
    SET_IS_PATIENT_INFO_IN_SESSION_STORAGE(state, isPatientInfoInSessionStorage) {
      state.isPatientInfoInSessionStorage += 1;
    },
    SET_PATIENT_AREA_CODE_CHANGE_COUNT(state) {
      state.patientAreaCodeChangeCount += 1;
    }
  },
  actions: {
    addSelectedTest({ getters }, test) {
      addSelectedTest(test.id, "isSelect", getters.orderTestSupportObj);
    },
    removeSelectedTest({ getters }, test) {
      removeSelectedTest(test.id, "isSelect", getters.orderTestSupportObj);
      // remove it from edit order if any
    },
    addOnFixedPromoValues({ getters, state, dispatch }, promoInfo) {
      if (!state.addOnFixedPromo.includes(promoInfo.promoId)) {
        state.addOnFixedPromo.push(promoInfo.promoId)
      }
    },
    addOnFixedVaVwTest({ getters, state, dispatch }, testId) {
      let descendantRootList = []
      let root = getters["tests/bfsTestList"].find(node => node.id === testId);
      if (!root) {
        return
      }
      dispatch('addOnFixedVaVwTestTubeInfo', { root, isFixedVaVw: 'true', isSelect: 'true' })
      // find add on va vw tests' parents
      dispatch('addOnFixedVaVwTestWithParents', root)
      // find all add on test and their descendants 
      getAllDescendants(root, descendantRootList)
      let descendantRootIdList = descendantRootList.map(i => i.id)
      state.addOnFixedVaVwTest.set(testId, descendantRootIdList)
    },
    setAddOnDisabledTests({ state, getters }, addOnDisaleSelectTests) {
      let { barcode, expiredAddonItemList } = addOnDisaleSelectTests;
      state.addOnAccessionId = barcode
      state.addOnExpiredTestList = expiredAddonItemList ? expiredAddonItemList.map(i => i.item_id) : [];
    },

    setAddOnPrevTubeInfo({ state }, addOnPrevTubeInfo) {
      let { actual_volume_required } = addOnPrevTubeInfo;
      let addOnPrevTubeInfoMap = new Map()
      for (const key in actual_volume_required) {
        addOnPrevTubeInfoMap.set(key, Number(actual_volume_required[key]))
      }
      state.addOnPrevTubeInfo = addOnPrevTubeInfoMap
    },

    setAddOnExpiredSoonAddonTests({ state, getters }, expiredSoonAddonTests) {
      console.log('expiredSoonAddonTests', expiredSoonAddonTests);
      if (expiredSoonAddonTests) {
        console.log("here")
      }
      expiredSoonAddonTests && expiredSoonAddonTests.forEach(i => {
        state.addOnExpiredSoonAddonTests.set(i.id, i.remainingStabilityDays)
      })
    },

    addOnFixedVaVwTestTubeInfo({ getters, state, dispatch }, rootInfo) {
      if (state.addOnPrevTubeInfo.size === 0) {
        return
      }
      if (state.isAddOnOrder.length === 0) {
        return
      }
      let { root, isFixedVaVw, isSelect } = rootInfo

      // test can be root or desendant
      let rootValue = root.value ? root.value : root

      // get all required tube names from the selected test
      let tubeNames = rootValue?.tubeInfo?.noOfTubes ? Object.keys(rootValue.tubeInfo.noOfTubes) : [];

      // assign the default tube info every time 
      state.addOnFixedVaVwTestTubeInfo = state.addOnPrevTubeInfo

      isSelect === 'true' && isFixedVaVw === 'false' && tubeNames.forEach(i => {
        if (state.addOnFixedVaVwTestTubeInfo.has(i)) {
          state.addOnFixedVaVwTestTubeInfo.set(
            i,
            state.addOnFixedVaVwTestTubeInfo.get(i) + Number(rootValue.tubeInfo.actual_volume_required[i])
          )
        }
      })

      isSelect === 'false' && tubeNames.forEach(i => {
        state.addOnFixedVaVwTestTubeInfo.set(
          i,
          state.addOnFixedVaVwTestTubeInfo.get(i) - Number(rootValue.tubeInfo.actual_volume_required[i])
        )
      })

      // empty the calcualted grey test every time when select or unselect a test
      state.addOnRequiredMoreNoOfTubesTests = []

      getters["tests/bfsTestList"].forEach(i => {
        // traverse va vw tests
        let rootValue = i.value ? i.value : i
        // if test contained in selectedItemList, addOnFixedVaVwTest or 
        // is the last test in the bundle from addOnFixedVaVwTest
        if (getters["selectedItemList"].map(i => i.id).includes(i.id) ||
          state.addOnFixedVaVwTest.has(i.id) ||
          (isFixedVaVw === 'true' && rootValue.id === rootInfo.root.id)
        ) {
          return
        }
        // test id -1 -2 and -3 don't have tubeInfo, will grey all the time
        if (i.id < 0) {
          state.addOnRequiredMoreNoOfTubesTests.push(i)
          return
        }
        let tubeNames = rootValue?.tubeInfo?.noOfTubes ? Object.keys(rootValue.tubeInfo.noOfTubes) : [];

        tubeNames.forEach(tubeName => {
          if (state.addOnFixedVaVwTestTubeInfo.has(tubeName) && tubeName !== 'BLOOD_FINGERPRICK') {
            // default VOLUME_FOR_EACH_TUBE is 4000
            let VOLUME_FOR_EACH_TUBE = 4000
            if (tubeName === 'EDTA') {
              VOLUME_FOR_EACH_TUBE = 3000
            }
            else if (tubeName === 'SST') {
              VOLUME_FOR_EACH_TUBE = 2000
            }

            let curTestTubeQuantity = Number(rootValue.tubeInfo.actual_volume_required[tubeName] ? rootValue.tubeInfo.actual_volume_required[tubeName] : 0)
            let deadVolumn = 1000
            let currentRequiredNoOfTubes = (
              state.addOnFixedVaVwTestTubeInfo.get(tubeName) + curTestTubeQuantity +
              deadVolumn) / VOLUME_FOR_EACH_TUBE

            // if add this test needs more tubes than add on fixed number of tubes, 
            // will grey it
            if (currentRequiredNoOfTubes > 1) {
              state.addOnRequiredMoreNoOfTubesTests.push(i)
            }
          } else {
            // grey thet test that requires different tube type or tube number != 1
            state.addOnRequiredMoreNoOfTubesTests.push(i)
          }
        })
      })

      state.addOnCustomRequiredMoreNoOfTubesTests = []

      state.panels.customPanelList.forEach(i => {
        if (state.panels.selectedCustomPanelIdList.includes(i.bundleId)) {
          return
        }

        let tubeNames = i.tubeInfo?.noOfTubes ? Object.keys(i.tubeInfo.noOfTubes) : [];

        if (!Object.keys(i.tubeInfo.noOfTubes).every(key => Array.from(state.addOnPrevTubeInfo.keys()).includes(key))) {
          state.addOnCustomRequiredMoreNoOfTubesTests.push(i.bundleId)
          return
        }
        tubeNames.forEach(tubeName => {
          if (i.tubeInfo.actual_number_of_tubes[tubeName] === 1) {
            // default VOLUME_FOR_EACH_TUBE is 4000
            let VOLUME_FOR_EACH_TUBE = 4000
            if (tubeName === 'EDTA') {
              VOLUME_FOR_EACH_TUBE = 3000
            }
            else if (tubeName === 'SST') {
              VOLUME_FOR_EACH_TUBE = 2000
            }

            let curTestTubeQuantity = Number(i.tubeInfo.actual_volume_required[tubeName] ? i.tubeInfo.actual_volume_required[tubeName] : 0)
            let deadVolumn = 1000
            let currentRequiredNoOfTubes = (
              state.addOnFixedVaVwTestTubeInfo.get(tubeName) + curTestTubeQuantity +
              deadVolumn) / VOLUME_FOR_EACH_TUBE

            if (currentRequiredNoOfTubes > 1) {
              state.addOnCustomRequiredMoreNoOfTubesTests.push(i.bundleId)
            }
          } else {
            // grey thet test that requires different tube type or tube number != 1
            state.addOnCustomRequiredMoreNoOfTubesTests.push(i.bundleId)
          }
        })
      })

      state.addOnShortcutRequiredMoreNoOfTubesTests = []

      state.favorites.shortcutList.forEach(i => {
        if (state.favorites.selectedShortcutIdList.includes(i.id)) {
          return
        }

        // if this shortcut does not have tube info, grey it
        if (!i.tubeInfo) {
          state.addOnShortcutRequiredMoreNoOfTubesTests.push(i.id)
          return
        }

        let tubeNames = i.tubeInfo?.noOfTubes ? Object.keys(i.tubeInfo.noOfTubes) : [];

        if (
          i.tubeInfo?.noOfTubes &&
          !Object.keys(i.tubeInfo.noOfTubes).every(key =>
            Array.from(state.addOnPrevTubeInfo.keys()).includes(key)
          )
        ) {
          state.addOnShortcutRequiredMoreNoOfTubesTests.push(i.id);
          return;
        }

        tubeNames.forEach(tubeName => {
          if (i.tubeInfo.actual_number_of_tubes[tubeName] === 1) {
            // default VOLUME_FOR_EACH_TUBE is 4000
            let VOLUME_FOR_EACH_TUBE = 4000
            if (tubeName === 'EDTA') {
              VOLUME_FOR_EACH_TUBE = 3000
            }
            else if (tubeName === 'SST') {
              VOLUME_FOR_EACH_TUBE = 4000
            }

            let curTestTubeQuantity = Number(i.tubeInfo.actual_volume_required[tubeName] ? i.tubeInfo.actual_volume_required[tubeName] : 0)
            let deadVolumn = 1000
            let currentRequiredNoOfTubes = (
              state.addOnFixedVaVwTestTubeInfo.get(tubeName) + curTestTubeQuantity +
              deadVolumn) / VOLUME_FOR_EACH_TUBE

            if (currentRequiredNoOfTubes > 1) {
              state.addOnShortcutRequiredMoreNoOfTubesTests.push(i.id)
            }
          } else {
            // grey thet test that requires different tube type or tube number != 1
            state.addOnShortcutRequiredMoreNoOfTubesTests.push(i.id)
          }
        })
      })
      console.log(state.addOnFixedVaVwTestTubeInfo, 'addOnFixedVaVwTestTubeInfo', getters.selectedItemList, 'state.selectedItemList')
    },

    addOnFixedVaVwTestWithParents({ state }, root) {
      if (!root) {
        return
      }
      let path = [];
      path.push(root);
      let currentNode = root.parent;
      while (currentNode !== null) {
        path.unshift(currentNode);
        currentNode = currentNode.parent;
      }

      let parentIds = path.map(x => x.id)

      for (let i = 0; i < parentIds.length; i++) {
        if (state.addOnFixedVaVwTestWithParents.get(parentIds[i])) {
          state.addOnFixedVaVwTestWithParents.set(
            parentIds[i],
            [...state.addOnFixedVaVwTestWithParents.get(parentIds[i]), root.id]
          )
        } else {
          state.addOnFixedVaVwTestWithParents.set(parentIds[i], [root.id])
        }
      }
    },
    addOnFixedDiscountPanel({ state, getters, dispatch }, bundleInfo) {
      // store all tests from bundleContent, as well as their descendants to addOnFixedVaVwTest
      let { packageList, testList } = bundleInfo.bundleContent
      let testIdList = testList ? testList.map(t => t.testId) : [];
      let packageIdList = packageList ? packageList.map(p => p.packageId) : [];
      let bundleContentTesetIds = testIdList.concat(packageIdList)
      state.addOnFixedDiscountPanel.set(bundleInfo.bundleId, bundleContentTesetIds)
      bundleContentTesetIds.forEach(i => dispatch('addOnFixedVaVwTest', i))
    },
    addOnFixedCustomPanel({ state, getters, dispatch }, panel) {
      // store all tests from custom panel, as well as their descendants to addOnFixedVaVwTest
      let { bundleId, bundleItemList } = panel
      state.addOnFixedCustomPanel.push(bundleId)
      bundleItemList.filter(i => i && i.itemId).forEach(i => dispatch('addOnFixedVaVwTest', i.itemId))
    },
    addOnFixedFavPanel({ state }, panel) {
      state.addOnFixedFavPanel.push(panel)
    },
    addOnFixedxChooseYPanel({ state, dispatch }, panel) {
      console.log(panel, 'panel')
      let selectedXChooseYTests = (panel.selectedSupplementIdList || []).concat(panel.selectedZoomerIdList || [])
      state.addOnFixedDiscountPanel.set(panel.bundleId, selectedXChooseYTests)
      selectedXChooseYTests.forEach(i => dispatch('addOnFixedVaVwTest', i))
    },

    async setCountryOptions({ commit }) {
      try {
        let { data } = await getCountryList();
        data.forEach(country => {
          country.label = country.countryName + " (" + country.countryNameTwoBytes + ")";
          country.value = country.countryNameTwoBytes;
        });
        commit("SET_COUNTRY_OPTIONS", data);
      } catch (err) {
        console.log("set country options error", err);
      }
    },

    addSelectedCustomPanel({ getters }, customPanel) {
      addSelectedCustomPanel(customPanel.bundleId, "isSelect", getters.orderTestSupportObj);
    },

    removeSelectedCustomPanel({ getters }, customPanel) {
      removeSelectedCustomPanel(customPanel.bundleId, "isSelect", getters.orderTestSupportObj)
    },

    addSelectedDiscountPanel({ getters }, discountPanel) {
      return addSelectedDiscountPanel(discountPanel.bundleId, "isSelect", getters.orderTestSupportObj);
    },

    removeSelectedDiscountPanel({ getters }, discountPanel) {
      removeSelectedDiscountPanel(discountPanel.bundleId, "isSelect", getters.orderTestSupportObj);
    },

    addSelectedShortcut({ getters }, shortcut) {
      addSelectedShortcut(shortcut.id, "isSelect", getters.orderTestSupportObj);
    },

    removeSelectedShortcut({ getters }, shortcut) {
      removeSelectedShortcut(shortcut.id, "isSelect", getters.orderTestSupportObj);
    },

    setIsClickCheckout({ commit }, isClicked) {
      commit("SET_IS_CLICK_CHECKOUT", isClicked);
    },

    addSelectedMultiChoosePanel({ getters }, multiChoosePanel) {
      addSelectedXChooseYPanel(multiChoosePanel.bundleId, "isSelect", getters.orderTestSupportObj);
    },

    removeSelectedMultiChoosePanel({ getters }, multiChoosePanel) {
      removeSelectedXChooseYPanel(multiChoosePanel.bundleId, "isSelect", getters.orderTestSupportObj);
    },

    // VP-15298: Deselect all VA tests, bundles, and shortcuts when VA panel is hidden
    // Note that x choose y panels are formed by VW test only, so we don't need to check them
    clearVaSelections({ state, getters, dispatch }) {
      const vaTestIds = new Set(state.tests.vaBfsList.map(n => n.id));

      // Deselect VA tests
      getters["tests/selectedTestList"]
        .filter(test => vaTestIds.has(test.id))
        .forEach(test => dispatch("removeSelectedTest", test));

      // Identify discount panels that contain VA tests
      const vaContainingBundleIds = new Set(
        state.panels.discountPanelList
          .filter(panel => panel.testIdsInPanel?.some(id => vaTestIds.has(id)))
          .map(panel => panel.bundleId)
      );

      // Deselect discount panels containing VA tests
      getters["panels/selectedDiscountPanelList"]
        .filter(panel => vaContainingBundleIds.has(panel.bundleId))
        .forEach(panel => dispatch("removeSelectedDiscountPanel", panel));

      // Deselect x-choose-y panels containing VA tests
      getters["panels/selectedXChooseYPanelList"]
        .filter(panel => vaContainingBundleIds.has(panel.bundleId))
        .forEach(panel => dispatch("removeSelectedMultiChoosePanel", panel));

      // Deselect shortcuts that contain VA tests directly or via a VA-containing bundle
      getters["favorites/selectedShortcutList"]
        .filter(shortcut =>
          shortcut.testIdList.some(id => vaTestIds.has(id)) ||
          shortcut.discountPanelIdList.some(id => vaContainingBundleIds.has(id))
        )
        .forEach(shortcut => dispatch("removeSelectedShortcut", shortcut));
    },

    async setDefaultSettings({ commit, state, rootState, dispatch }) {
      try {
        const res = await getDefaultOrderSettings();
        const settings = res?.data && typeof res.data === "object" ? res.data : null;
        if (settings) {
          commit("SET_DEFAULT_SETTINGS", settings);
        }
        const hash = window.location.hash;
        const queryString = hash.includes('?') ? hash.substring(hash.indexOf('?')) : '';
        const query = Object.fromEntries(new URLSearchParams(queryString));
        const { draftId, reorderSampleId, editOrderSampleId, addOnSampleId } = query;
        const draftKey = draftId || reorderSampleId || editOrderSampleId || addOnSampleId;
        if (!draftKey && !state.order.paymentMethod) {
          const defaultChargeMethod =
            settings?.chargeMethod
            || settings?.defaultChargeMethod
            || settings?.defaultPaymentMethod
            || settings?.paymentMethod
            || "";
          if (defaultChargeMethod) {
            dispatch("order/setPaymentMethod", defaultChargeMethod);
          }
        }
        const currency = rootState.currency;
        const currencyName = currency && currency.name ? currency.name.toLowerCase() : "usd";
        const isNonUsd = currencyName !== "usd";
        const noVaTestsMenu = state.tests.vaRootNodeList.length === 0;
        // For non-USD users: default isDbsVersion to true if no VA tests menu; otherwise use API
        if (isNonUsd && noVaTestsMenu) {
          commit("SET_IS_DBS_VERSION", true);
        } else if (!draftKey && settings && typeof settings.displayHomeMenuForNewOrder === "boolean") {
          commit("SET_IS_DBS_VERSION", settings.displayHomeMenuForNewOrder);
        }

      } catch (error) {
        console.error(error);
      }

    },

    setProcessingFeeAndCapOffValue({ commit }) {
      getProcessingFeeCapOffValue().then(res => {
        commit("SET_PROCESSING_CAP_OFF_VALUE", res.data);
      })
    },

    setDiscountMap({ commit }, discountMap) {
      commit("SET_DISCOUNT_MAP", discountMap);
    },

    addSelectedSeasonalPromo({ getters, state }, promo) {
      if (state.isAddOnOrder.length !== 0 && !state.addOnFixedPromo.includes(promo.id)) {
        return
      }
      addSelectedSeasonalPromo(promo, "isSelect", getters.orderTestSupportObj);
    },

    removeSelectedSeasonalPromo({ getters }, promo) {
      removeSelectedSeasonalPromo(promo, "isSelect", getters.orderTestSupportObj);
    },

    setBundleReplaceTriggered({ commit }) {
      commit("SET_BUNDLE_REPLACE_TRIGGERED");
    },

    setIsDbsVersion({ commit }, isDbsVersion) {
      commit("SET_IS_DBS_VERSION", isDbsVersion);
    },

    async setDbsMap({ commit, dispatch }, dbsMappings) {
      try {
        commit("SET_DBS_MAP", dbsMappings);
        dispatch("getDbsWebLink");
        dispatch("panels/setSerumAndDbsDiscountPanelList");
      } catch (error) {
        console.log(error)
      }
    },

    async setBestDealMapping({ commit }) {
      try {
        let currency = parseJson(localStorage.getItem("currency"));
        let currencyName = currency.name ? currency.name.toLowerCase() : "usd";
        const res = await getBestDealMapping(currencyName);
        commit("SET_BEST_DEAL_MAPPING", res.data);
      } catch (error) {
        console.log(error)
      }
    },

    switchToDbs({ commit }) {
      commit("SWITCH_TO_DBS");
    },

    switchToSerum({ commit }) {
      commit("SWITCH_TO_SERUM");
    },

    setSearchTestOptions({ commit }, testOptions) {
      commit("SET_SEARCH_TEST_OPTIONS", testOptions);
    },

    clearSelectedItemList({ state, getters }) {
      clearAllSelectedItems(getters.orderTestSupportObj);
      // de select all favorite shortcut
      state.favorites.shortcutList.forEach(shortcut => {
        shortcut.isSelect = false;
      });
    },

    initializeStore({ state, commit, dispatch, getters }) {
      commit("SET_DBS_MAP", []); // clear to initialize dbs and serum discountPanelList
      commit("panels/SET_CUSTOM_PANEL_LIST", []);
      commit("favorites/SET_SHORTCUT_LIST", []);
      commit("favorites/SET_FAVORITE_TEST_ID_LIST", []);
      commit("tests/SET_VA_ROOT_NODE_LIST", []);
      commit("tests/SET_VA_BFS_LIST", []);
      commit("tests/SET_VW_ROOT_NODE_LIST", []);
      commit("tests/SET_VW_BFS_LIST", []);
      commit("panels/SET_DISCOUNT_PANEL_LIST", []);

      commit("promotions/SET_PROMOTION_LIST", []);
      commit("exceptions/SET_EXCEPTION_MAP", []);
      commit("order/SET_PAYMENT_METHOD", "");
      commit("SET_IS_CLICK_CHECKOUT", false);
      commit("SET_DUPLICATE_TEST", []); // array of object. {testName: "Wheat Zoomer", testId: test_1, duplicatedTestsFrom: ['Anti-aging','Imflamation Advanced']}
      commit("order/SET_LAB_PROCESSING_FEE", 0);
      commit("order/SET_SEND_DATE", { date: "", time: "" });
      commit("order/SET_EDIT_ORDER_SAMPLE_ID", null);
      commit("order/RESET_SHIPPING_FEE");
      commit("tests/SET_VW_CATEGORIES", []);
      commit("SET_DEFAULT_SETTINGS", {});
      commit("SET_PROCESSING_CAP_OFF_VALUE", {});
      commit("SET_TEST_SUGGESTIONS", []);
      commit("SET_IS_BACK_FROM_CHECKOUT_PAGE", false);
      commit("orderDraft/SET_ORDER_DRAFT", {});
      commit("orderDraft/SET_CURRENT_DRAFT_ID", "");
      commit("user/SET_PATIENT_COUNTRY", "");
      commit("SET_IS_RESTORING_ITEMS", false);
      // Use splice to clear selected lists (preserves array references for reactivity)
      clearAllSelectedItems(getters.orderTestSupportObj);
      // de-select all favorite shortcuts
      state.favorites.shortcutList.forEach(shortcut => {
        shortcut.isSelect = false;
      });
      // Use proper mutation to clear merchandise (preserves reactivity)
      commit("merchandise/CLEAR_ALL_SELECTED_MERCH");
      dispatch("familyDiscount/setFamilyMembers", []);
    },

    async markUpShortcutFetchData({ state, getters, dispatch }, orderPageFetchDataWTubeInfo) {
      // get discountMap && get all promotions
      await Promise.allSettled([
        dispatch("fetchDiscountMap"),
        dispatch("promotions/setPromotionList"),
        dispatch("promotions/setPromotionMap")
      ]);
      let modifiedDiscountMap = getModifiedDiscountMap(state.promotions.seasonalPromotionList, state.discountMap, getters["tests/bfsTestList"]);
      dispatch("setDiscountMap", modifiedDiscountMap);
    },


    async orderPageFetchData({ state, getters, dispatch }, orderPageFetchDataWTubeInfo) {
      console.log('[orderPageFetchData] START');
      const jwtToken = sessionStorage.getItem("jwtToken") || localStorage.getItem("jwtToken");
      if (jwtToken && !sessionStorage.getItem("jwtToken")) {
        sessionStorage.setItem("jwtToken", jwtToken);
      }

      // get all tests
      console.log('[orderPageFetchData] vaRootNodeList.length before:', state.tests.vaRootNodeList.length);
      if (state.tests.vaRootNodeList.length === 0) {
        console.log('[orderPageFetchData] calling setAllTests...');
        if (orderPageFetchDataWTubeInfo) {
          await dispatch("tests/setAllTests", true);
        } else {
          await dispatch("tests/setAllTests");
        }
        console.log('[orderPageFetchData] setAllTests DONE, vaRootNodeList.length after:', state.tests.vaRootNodeList.length);
      } else {
        console.log('[orderPageFetchData] skipping setAllTests, data already exists');
      }
      // get customer panels
      if (state.panels.customPanelList.length === 0) {
        await dispatch("panels/setCustomPanelList");
      }
      // get favorite tests
      // if (state.favorites.favoriteTestIdList.length === 0) {
      //   dispatch("favorites/setFavoriteTestIdList");
      // }

      // get Dbs mapping
      if (state.dbsMap.length === 0) {
        await dispatch("setDbsMap");
      }

      if (Object.keys(state.bestDealSupportMapping).length === 0) {
        await dispatch("setBestDealMapping")
      }

      // get discountMap && get all promotions
      await Promise.allSettled([
        dispatch("fetchDiscountMap"),
        dispatch("promotions/setPromotionList"),
        dispatch("promotions/setPromotionMap")
      ]);
      let modifiedDiscountMap = getModifiedDiscountMap(state.promotions.seasonalPromotionList, state.discountMap, getters["tests/bfsTestList"]);
      dispatch("setDiscountMap", modifiedDiscountMap);

      // NOTE: Shortcuts are NOT loaded here in orderPageFetchData
      // They will be loaded explicitly by PlaceOrderDialog after all data is ready
      // This ensures test/bundle data is fully loaded before shortcuts calculate prices

      // get default settings && set isDbsVersion value
      if (_.isEmpty(state.defaultSettings)) {
        await dispatch("setDefaultSettings");
      }

      // get processing fee and cap off value
      if (_.isEmpty(state.processingFeeAndCapOffValue)) {
        dispatch("setProcessingFeeAndCapOffValue");
      }
      dispatch("setMarkupScheme");
      await dispatch("merchandise/setMerchandise");
    },

    async addOnOrderPageFetchData({ state, getters, dispatch }, orderPageFetchDataWTubeInfo) {
      const jwtToken = sessionStorage.getItem("jwtToken") || localStorage.getItem("jwtToken");
      if (jwtToken && !sessionStorage.getItem("jwtToken")) {
        sessionStorage.setItem("jwtToken", jwtToken);
      }

      // get all tests
      if (state.tests.vaRootNodeList.length === 0) {
        if (orderPageFetchDataWTubeInfo) {
          await dispatch("tests/setAllTests", true);
        } else {
          await dispatch("tests/setAllTests");
        }
      }
      // get customer panels
      if (state.panels.customPanelList.length === 0) {
        await dispatch("panels/setCustomPanelListWTubrInfo");
      }
      // get favorite tests
      // if (state.favorites.favoriteTestIdList.length === 0) {
      //   dispatch("favorites/setFavoriteTestIdList");
      // }

      // get Dbs mapping
      if (state.dbsMap.length === 0) {
        await dispatch("setDbsMap");
      }

      if (Object.keys(state.bestDealSupportMapping).length === 0) {
        await dispatch("setBestDealMapping")
      }

      // get discountMap && get all promotions
      await Promise.allSettled([
        dispatch("fetchDiscountMap"),
        dispatch("promotions/setPromotionList"),
        dispatch("promotions/setPromotionMap")
      ]);
      let modifiedDiscountMap = getModifiedDiscountMap(state.promotions.seasonalPromotionList, state.discountMap, getters["tests/bfsTestList"]);
      dispatch("setDiscountMap", modifiedDiscountMap);
      // get favorite shortcuts
      if (state.favorites.shortcutList.length === 0) {
        await dispatch("favorites/setShortcutList");
      }
      // get all vw categories
      // if (state.tests.vwCategories.length === 0) {
      //   dispatch("tests/setVwCategories");
      // }
      // get test suggestions
      // if (state.testSuggestions.length === 0) {
      //   dispatch("setTestSuggestions");
      // }
      // get default settings && set isDbsVersion value
      if (_.isEmpty(state.defaultSettings)) {
        await dispatch("setDefaultSettings");
      }

      // get processing fee and cap off value
      if (_.isEmpty(state.processingFeeAndCapOffValue)) {
        dispatch("setProcessingFeeAndCapOffValue");
      }
      dispatch("setMarkupScheme");
      await dispatch("merchandise/setMerchandise");

    },

    setIsBackFromCheckoutPage({ commit }, isBackFromCheckoutPage) {
      commit("SET_IS_BACK_FROM_CHECKOUT_PAGE", isBackFromCheckoutPage);
    },
    getDbsWebLink({ state }) {
      state.dbsMap.forEach((map) => {
        let dbsTestNode = state.tests.vwBfsList.find(node => node.id === map.dbsItemId);
        if (dbsTestNode) {
          let serumTestNode = state.tests.vwBfsList.find(node => node.id === map.originalItemId);
          if (serumTestNode) {
            dbsTestNode.value.weblink = serumTestNode.value.weblink;
          }
        }
      });
    },
    async fetchDiscountMap({ state, commit }) {
      if (_.isEmpty(state.discountMap)) {
        let { data } = await getOfficialBundleMappingApi();
        commit("SET_DISCOUNT_MAP", data);
      }
    },
    setIsPatientInfoInSessionStorage({ commit }) {
      commit("SET_IS_PATIENT_INFO_IN_SESSION_STORAGE");
    },
    setPatientAreaCodeChangeCount({ commit }) {
      commit("SET_PATIENT_AREA_CODE_CHANGE_COUNT");
    },

    async setMarkupScheme({ state, getters }) {
      try {
        let userInfo = state.user.userInfo;
        let { isClinic, customer_id, clinic_id } = userInfo;
        let account_id = isClinic ? customer_id : clinic_id;
        let account_type = isClinic ? "clinic" : "customer";
        let testNodeList = getters["tests/bfsTestList"];
        let bundleList = getters["panels/bundleList"];
        let shortcutList = state.favorites.shortcutList;
        let promotionList = state.promotions.seasonalPromotionList;
        let { data } = await getOrderMarkupSchemesApi({
          account_type,
          account_id,
          customer_id,
          clinic_id,
          query_all: true
        });
        if (data) {
          setItemMarkupPriceAndVersion(data.markup_schemes, testNodeList, bundleList, shortcutList, promotionList);
        }
      } catch (err) {
        console.log("setMarkupScheme err", err);
      }
    }
  },
  modules: {
    user,
    tests,
    panels,
    order,
    favorites,
    program,
    promotions,
    orderDraft,
    noteTemplate,
    exceptions,
    redirect,
    merchandise,
    familyDiscount,
    // merchPromotion,
  }
};

export default orderTest;